import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppSend = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3201 9.18994V4.68994C19.3201 4.39157 19.2015 4.10542 18.9906 3.89445C18.7796 3.68347 18.4934 3.56494 18.1951 3.56494H4.69507C4.3967 3.56494 4.11055 3.68347 3.89957 3.89445C3.68859 4.10542 3.57007 4.39157 3.57007 4.68994V17.0649C3.57007 17.3633 3.68859 17.6495 3.89957 17.8604C4.11055 18.0714 4.3967 18.1899 4.69507 18.1899H9.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0316 11.6225L11.4656 14.8655C11.3399 14.9189 11.2321 15.0072 11.155 15.12C11.0779 15.2327 11.0346 15.3652 11.0304 15.5017C11.0261 15.6382 11.061 15.7731 11.131 15.8904C11.2009 16.0077 11.303 16.1026 11.4251 16.1638L14.0936 17.498L15.4279 20.1673C15.4891 20.2892 15.5838 20.3912 15.701 20.4611C15.8181 20.5311 15.9528 20.5661 16.0892 20.5621C16.2256 20.558 16.358 20.5152 16.4708 20.4384C16.5837 20.3617 16.6723 20.2544 16.7261 20.129L19.9751 12.563C20.0321 12.4311 20.048 12.2852 20.0209 12.1441C19.9938 12.003 19.9249 11.8734 19.8232 11.772C19.7214 11.6706 19.5916 11.6021 19.4504 11.5754C19.3093 11.5488 19.1634 11.5652 19.0316 11.6225V11.6225Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57007 6.93994H19.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
